module.exports = __webpack_public_path__ + "img/csj.ecd6982d.png";